import { setSourceMapRange } from 'typescript';
import api from '../axios/axiosConfig';
import type { AuthContextType } from '../context/AuthContext';
//import { registerPushNotification } from '../services/userService';

export const authenticateUser = async (
  email: string,
  password: string,
  auth: AuthContextType
) => {
  try {
    const response = await api.post(`/auth`, {
      email,
      password,
    });
    if (response.data.token) {
      //localStorage.setItem('user', JSON.stringify(response.data));
      //localStorage.setItem('token', JSON.stringify(response.data.token).replace(/"/g, ''));
      const token = response.data.token;
      auth.setToken(token, `token-${window.location.pathname.split('/')[1]}`);
      //await registerPushNotification(auth.expoPushToken,auth.platform,auth.appVersion);
    }
    return response.data;
  } catch (error: any) {
    console.error('Erro na autenticação', error.response);
    throw error;
  }
};
